<template>
  <div style="height: 100%" class="pa-4">
    <v-row justify="space-between">
      <v-col v-if="!noHeader">
        <div class="font-weight-bold basic--text text-center">{{ 'Contact Details'.toUpperCase() }}</div>
      </v-col>
    </v-row>
    <v-form v-model="dataValid" ref="form">
      <v-row justify="space-between">
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="Address" required :rules="textRules" :disabled="!canEdit" v-model="obj.contactAddress"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select :items="countries" item-value="id" item-text="name" outlined dense label="Country" required :rules="textRules" :disabled="!canEdit" v-model="selectedCountry"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select :items="states" item-value="id" item-text="name" outlined dense label="State" required :rules="textRules" :disabled="!canEdit" v-model="selectedState"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-select :items="lgas" item-value="id" item-text="name" outlined dense label="LGA" required :rules="textRules" :disabled="!canEdit" v-model="obj.lgaId"></v-select>
        </v-col>
      </v-row>
    </v-form>

    <v-card-actions class="mt-6">
      <v-spacer></v-spacer>
      <v-btn color="basic" class="white--text" @click="$emit('back')" depressed>{{ noHeader ? 'Back' : 'Previous' }}</v-btn>
      <v-btn color="error" depressed @click="$refs.form.reset()" v-if="canEdit && !noHeader">Reset</v-btn>
      <v-btn color="primary" depressed @click="saveData" :disabled="!dataValid" v-if="canEdit">{{ noHeader ? 'Save' : 'Proceed' }}</v-btn>
      <v-btn color="info" depressed @click="success" v-if="!canEdit || (getInformation != null && getInformation.contactLga != null)">Skip</v-btn>
    </v-card-actions>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>
<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import {mapGetters} from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import ValidationRules from "@/shared/ValidationRules";
import StudentStatus from "@/shared/StudentStatus";
import XButton from "@ui/widgets/XButton.vue";
import XTextField from "@ui/widgets/XTextField.vue";
import XSelect from "@ui/widgets/XSelect.vue";
export default {
  name: "ContactDetails",
  props: {
    noHeader: Boolean
  },
  components: {XSelect, XTextField, XButton, MessageBox, LoadingDialog},
  data: () => ({
    obj: {},
    countries: [],
    states: [],
    lgas: [],
    selectedLga: {},
    selectedState: null,
    selectedCountry: null,
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    textRules: ValidationRules.textRules,
    dataValid: true,
  }),
  methods: {
    success() {
      this.$emit('success')
    },


    check(){
      this.loading = true;
      Api.applicants.nextToContactDetails(this.getUser.id)
      .then(res => {
        this.loading = false;
        this.$store.commit("setCurrentUser", res.data)
      }).catch(err => ErrorResolver.checkErrors(this, err))
      .finally(() => this.loading = false)
    },

    saveData(){

      this.loading = true
      Api.applicants.contactDetailsUpdate(this.getUser.id, this.obj)
          .then(res => {
            this.message = 'Contact details updated'
            this.messageType = 'success'
            this.messageShow = true
            this.$store.commit('setInformation', res.data)
            this.success()
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadCountries(){
      this.loading = true
      Api.nationality.getCountries()
          .then(res => this.countries = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadStates(){
      this.loading = true
      this.states = []
      this.lgas = []
      Api.nationality.getStates(this.selectedCountry)
          .then(res => {
            this.states = res.data
            // update state object
            if(this.getInformation != null)
              this.selectedState = this.getInformation.state.id
          })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadLgas(){
      this.loading = true
      this.lgas = []
      Api.nationality.getLgas(this.selectedState)
          .then(res => this.lgas = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    prefillData() {
      if (this.getInformation != null) {
        let i = this.getInformation
        this.obj.contactAddress = i.contactAddress

        if(i.contactLga != null) {
          this.obj.countryId = i.contactLga.state.country.id
          this.selectedCountry = i.contactLga.state.country.id
          this.obj.stateId = i.contactLga.state.id
          this.obj.lgaId = i.contactLga.id
        }
      }
    }
  },

  computed: {
    ...mapGetters(['getUser', 'getInformation', 'getApplicantFee']),
    canEdit: function(){
      // status still not upto application complete
      return this.getUser != null && (StudentStatus[this.getUser.studentStatus].value <= StudentStatus.APPLICATION_PENDING.value)
        && this.getUser.admission.applicationType.contactDetailsEnabled
    }
  },

  watch: {
    selectedCountry: function(newVal){
      if(newVal != null){
        this.states = []
        this.loadStates()
      }
    },

    selectedState: function(newVal){
      if(newVal != null && !this.isEditing){
        this.loadLgas()
      }
    },

    getInformation: function(){
      if(this.getInformation != null){
        if(this.getInformation.contactAddress != null)
          this.success()
        else
          this.prefillData()
      }

    },

    getUser: function(){
      if(this.getUser != null) {
        if(this.getUser.admission.applicationType.contactDetailsEnabled === false)
          this.success()
        else
          this.prefillData()
      }
    }
  },


  created() {
    this.loadCountries()
    if(this.getUser != null) {
      if(this.getUser.admission.applicationType.contactDetailsEnabled === false)
        this.success()
      else{
        this.prefillData();
        this.check();
      }
    }
    this.noHeader && this.$emit('update-title', "Contact Details")
    // if contact data already completed
    // if(this.getInformation != null && this.getInformation.contactAddress != null)
    //   this.success()
  }
}
</script>

<style scoped>

</style>
